// extracted by mini-css-extract-plugin
export default {"animateScroll":"Home_animateScroll__ALUWS","scroll":"Home_scroll__Z9x0S"};